/** The Add-to-CRM modal's copy, keyed by provider. Extracted per {@link enCrmProviders}. */
export const enCrmAddTo = {
	title: "Add to {{provider}}",
	description: "Choose what should be created for {{count}} selected prospect(s) in {{provider}}.",
	submit: "Add to CRM",
	success: "CRM sync has been queued.",
	error: "Failed to queue CRM sync. Please try again.",
	provider: {
		hubspot: "HubSpot",
		zoho: "ZohoCRM",
		pipedrive: "Pipedrive",
		msdynamics: "Dynamics 365",
		salesforce: "Salesforce",
	},
	entity: {
		contact: "Contact",
		account: "Account",
		lead: "Lead",
		deal: "Deal",
	},
	list: {
		label: "List",
		help: "The list this lead is synced from. Dynamics 365 names the marketing list after the campaign on this list, and the campaign after the list itself.",
	},
	owner: {
		label: "Owner",
		help: "Assign every created record to this CRM user. Leave empty to use the connection's default owner.",
	},
	help: {
		hubspot: "Lead can be selected alone. Deal selects Contact and Account automatically.",
		zoho: "Lead is exclusive. Deal creates Contact and Account as well.",
		pipedrive: "Contact and Account are mandatory. Lead and Deal are mutually exclusive.",
		msdynamics: "Contact and Account are mandatory. Lead and Opportunity are mutually exclusive.",
		salesforce: "Contact and Account are mandatory. Lead and Opportunity are mutually exclusive.",
	},
};

/** The per-provider `basics.addTo<Provider>` labels the table footer and lead panel render. */
export const enCrmAddToBasics = {
	addToHubspot: "Add to HubSpot",
	addToZoho: "Add to ZohoCRM",
	addToPipedrive: "Add to Pipedrive",
	addToDynamics: "Add to Dynamics 365",
	addToSalesforce: "Add to Salesforce",
};
